import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import Geosuggest from 'react-geosuggest';

import './Friends.css';
import { EventViewSplitPane } from './Event'
import { Modal, ComboBox, PublicityPicker, PhonePicker, ConfirmModal, EmptyState, LoadingState } from './Common';
import Redirect from 'react-router-dom/Redirect';

export default class Friends extends Component {
    constructor(p) {
        super(p)
        this.state = {
            activeTab: "Friends",
            userTabs: ["Friends", "Team Mates"/*, "Requests"*/]
        }
    }

    render() {
        const settings = FakeData.___("F",{
            "can_see_friends":"Friends"
        }, this.props.profile, []);
        if(!settings.can_see_friends){
            return(
                <div className="default-view" style={{ backgroundColor: "#fff",  paddingBottom: "20px" }}>
                    <EmptyState isShown={true} text="Content preview is disabled by owner" icon="block"/>
                </div>
            )
        }
        return (
            <div className="default-view" style={{ backgroundColor: "#fff",  paddingBottom: "20px" }}>
                <div className="view-with-tabs">
                    <div className="view-with-tabs-head">
                        {
                            this.state.userTabs.map((item, i) => {
                                if(!this.props.profile.isAdmin && item === "Requests"){
                                    return null;
                                }
                                return (
                                    <div key={i} className={(item === this.state.activeTab) ? "view-with-tabs-head-item group-mem-count-holder active" : "view-with-tabs-head-item group-mem-count-holder"} onClick={() => this.setState({ activeTab: item })}>
                                        {item}
                                        {item === "Requests" &&
                                            <span className="group-mem-count">{FakeData.shortDigit(FakeData.listify(this.props.profile.relations).length).text}</span>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="view-with-tabs-body">
                        <_Friends {...this.props} active={this.state.activeTab} />
                        <TeamMates {...this.props} active={this.state.activeTab} />
                        <EmptyState isShown={(FakeData.listify([]).length === 0) ? false : true} text="No friends were found!" icon="people" />
                    </div>
                </div>
            </div>
        );
    }
}

class _Friends extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            friends: [],
            activeTab: "All Friends",
            filter: ""
        }
    }

    componentDidMount() {
        FakeData.mountState("_friends", true);
        this.getData()
    }

    componentWillMount() {
        FakeData.mountState("_friends", false);
    }

    getData = () => {
        const _that = this;
        const dataTo = {
            userId: this.props.profile.id
        }

        FakeData.post("/getUserFriends.php?auth0", dataTo, {
            success(res) {
                if (!FakeData.isMounted("_friends")) {
                    return;
                }

                _that.setState({ friends: res, isLoading: false });
                setTimeout(() => {
                    _that.getData()
                }, 1000)
            },
            error(err) {
                _that.setState({ isLoading: false })
                setTimeout(() => {
                    _that.getData()
                }, 5000)
            }
        })
    }

    getCurrentList = () => {
        const { friends, activeTab, filter } = this.state;
        const { profile } = this.props;
        if (activeTab === "All Friends") {
            return friends.filter((item) => {
                return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
            });
        } else if (activeTab === "Recently Added") {
            return friends.filter((item) => {
                return item.isRecent && item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
            })
        } else if (activeTab === "Sports Friends") {
            return friends.filter((item) => {
                const list = FakeData.listify(item.mySport).filter((_item) => {
                    return this.inSports(_item, profile.mySport) && item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
                })
            })
        } else if (activeTab === "Current City") {
            return friends.filter((item) => {
                return (item.placesLived.current && item.placesLived.current.name === profile.placesLived.current.name) && item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
            })
        } else if (activeTab === "Hometown") {
            return friends.filter((item) => {
                return (item.placesLived.home && item.placesLived.home.name === profile.placesLived.home.name) && item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
            })
        } else {
            return friends.filter((item) => {
                return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
            });
        }
    }

    inSports = (sport, sports = []) => {
        const list = sports.filter((item) => {
            return item.id === sport.id
        })
        if (list.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    willRenderItem = (item = { name: "" }) => {
        const { filter } = this.state;
        if (item.name.toLowerCase().indexOf(filter.toLowerCase()) === -1) {
            return null;
        }
    }

    render = () => {
        const { isLoading, friends, activeTab, filter } = this.state;
        const { isAdmin, profile } = this.props;
        if (this.props.active !== "Friends") {
            return null;
        }

        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text="Loading" />
            )
        }
        if(activeTab === "Find Friends +"){
            <Redirect to={{pathname:"/search"}}/>
        }

        return (
            <EventViewSplitPane isExtended="true" active={this.state.activeTab} items={profile.isAdmin?["All Friends", "Recently Added", "Sports Friends", "Current City", "Hometown", "Find Friends +"]:["All Friends", "Recently Added", "Sports Friends", "Current City", "Hometown"]} setView={(d) => {
                if(d === "Find Friends +"){
                    window.location = "/search";
                } else{
                    this.setState({
                        activeTab: d
                    });
                }
            }}>
                {(activeTab !== "Find Friends +" && this.getCurrentList().length > 0) &&
                    <div className="group-members-view-list-filter-search" style={{marginBottom:"20px",marginTop:"-25px"}}>
                        <input value={filter} placeholder="Find member" style={{flex:1}} onChange={(e) => {
                            this.setState({ filter: e.target.value })
                        }} />
                        <i className="material-icons">search</i>
                    </div>
                }
                {activeTab !== "Find Friends +" &&
                    <div className="family-members">
                        {
                            this.getCurrentList().map((item, i) => {
                                //this.willRenderItem(item);
                                return (
                                    <FriendItem key={i} user={item} isAdmin={profile.isAdmin} />
                                )
                            })
                        }
                        {profile.isAdmin &&
                            <div className="family-member" onClick={() => {
                                this.setState({ activeTab: "Find Friends +" });
                            }}>
                                <div className="family-member-user" tabIndex="0">
                                    <img src="images/add_friend.svg" />
                                    <div>
                                        <span>Add Friends</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
                {activeTab !== "Find Friends +" &&this.getCurrentList().length === 0 &&
                    <EmptyState isShown={(this.getCurrentList().length === 0) ? true : true} text="No one found!" icon="people" />
                }
            </EventViewSplitPane>
        )
    }
}

class FriendItem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isEditting: false,
            user: this.props.user,
            privacy: this.props.user.privacy,
            isDeleting: false
        }
    }

    changePrivacy() {
        const _that = this
        const dataTo = {
            id: this.props.user.rawId,
            value: this.state.privacy
        }

        FakeData.post("/changeRelationshipPrivacy.php?auth0", dataTo, {
            success: ((res) => {
                //console.log(res)
            }),
            error: ((err) => {

            })
        }, true, "Data Saved!", ((res) => { }))
    }

    remove() {
        const _that = this
        const dataTo = {
            id: this.props.user.rawId
        }

        FakeData.post("/deleteRelationship.php?auth0", dataTo, {
            success: ((res) => {
                _that.setState({ isDeleting: false });
            }),
            error: ((err) => {

            })
        }, true, "Data Removed!", ((res) => { }))
    }

    setNotice = (mode) => {
        const _that = this
        const dataTo = {
            id: this.props.user.id,
            type: "F",
            settings: this.props.user.id + "_F_" + FakeData.getData("yoo").id + "_F",
            settingMode: mode,
            yourId: FakeData.getData("yoo").id
        }

        FakeData.post("/getNoticeFrom.php?auth0", dataTo, {
            success: ((res) => {
                //console.log(res)
            }),
            error: ((err) => {

            })
        }, true, "Data Saved!", ((res) => { }))
    }

    render() {
        const user = this.props.user
        return (
            <div className="family-member" tabIndex="0" ref={(ref) => this.elem = (ref === null) ? this.elem : ref} onFocus={(e) => {
                if (this.state.isEditting) {
                    e.preventDefault()
                }
            }} onContextMenu={(e) => {
                if (this.state.isEditting) {
                    e.preventDefault()
                }
                this.elem.focus();
                e.preventDefault()
            }}>
                <div className="family-member-user">
                    <img className="avatar" src={user.image} />
                    <div>
                        <p>{user.name}</p>
                        <span>{FakeData.shortDigit(FakeData.listify(user.friends).length, "friend").data}</span>
                    </div>
                    {this.state.isEditting &&
                        <PublicityPicker onChange={(e) => {
                            const _that = this
                            _that.setState({ privacy: e, isEditting: false });
                            _that.changePrivacy()
                        }} />
                    }
                </div>
                {this.props.isAdmin &&
                    <div className="family-member-menu">
                        {!this.state.isEditting && !user.isNoticeBlocked &&
                            <span onClick={() => {
                                this.setNotice(1)
                                this.elem.blur()
                            }}>Get Notifications</span>
                        }
                        {!this.state.isEditting && user.isNoticeBlocked &&
                            <span onClick={() => {
                                this.setNotice(0)
                                this.elem.blur()
                            }}>Block Notifications</span>
                        }
                        {!this.state.isEditting &&
                            <span onClick={() => {

                                this.elem.blur()
                            }}>Suggest friends</span>
                        }
                        {!this.state.isEditting &&
                            <span onClick={() => {
                                this.setState({ isDeleting: true })
                                this.elem.blur()
                            }}>Remove Friend</span>
                        }
                        {!this.state.isEditting &&
                            <span onClick={() => {
                                this.setState({ isEditting: true })
                                this.elem.blur()
                            }}>Change Privacy</span>
                        }

                        {this.state.isEditting &&
                            <span onClick={() => {
                                this.setState({ isEditting: false })
                                this.elem.blur()
                            }}>Cancel</span>
                        }
                    </div>
                }
                <ConfirmModal message="Are you sure you want to remove this person as your friend?<br/>" isOpen={this.state.isDeleting}
                    data={""}
                    onOkay={(data) => {
                        this.remove(data)
                    }}
                    onCancel={() => {
                        this.setState({
                            isDeleting: false
                        })
                    }} />
            </div>
        );
    }
}

class TeamMates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            friends: [],
            activeTab: "All Team Mates",
            filter:""
        }
    }

    componentDidMount() {
        FakeData.mountState("_team_mates", true);
        this.getData()
    }

    componentWillMount() {
        FakeData.mountState("_team_mates", false);
    }

    getData = () => {
        const _that = this;
        const dataTo = {
            userId: this.props.profile.id
        }

        FakeData.post("/getUserTeamMates.php?auth0", dataTo, {
            success(res) {
                if (!FakeData.isMounted("_team_mates")) {
                    return;
                }

                _that.setState({ friends: res, isLoading: false });
                setTimeout(() => {
                    _that.getData()
                }, 1000)
            },
            error(err) {
                _that.setState({ isLoading: false })
                setTimeout(() => {
                    _that.getData()
                }, 5000)
            }
        })
    }

    getCurrentList = () => {
        const { friends, activeTab, filter } = this.state;
        const { profile } = this.props;
        if (activeTab === "All Team Mates") {
            return friends.filter((item) => {
                return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
            });
        } else if (activeTab === "Recently Added") {
            return friends.filter((item) => {
                return item.isRecent && item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
            })
        } else if (activeTab === "by Sport") {
            return friends.filter((item) => {
                const list = FakeData.listify(item.mySport).filter((_item) => {
                    return this.inSports(_item, profile.mySport) && item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
                })
            })
        } else if (activeTab === "Current City") {
            return friends.filter((item) => {
                return (item.placesLived.current && item.placesLived.current.name === profile.placesLived.current.name) && item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
            })
        } else if (activeTab === "Hometown") {
            return friends.filter((item) => {
                return (item.placesLived.home && item.placesLived.home.name === profile.placesLived.home.name) && item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
            })
        } else {
            return friends.filter((item) => {
                return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
            });
        }
    }

    inSports = (sport, sports = []) => {
        const list = sports.filter((item) => {
            return item.id === sport.id
        })
        if (list.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    willRenderItem = (item = { name: "" }) => {
        const { filter } = this.state;
        if (item.name.toLowerCase().indexOf(filter.toLowerCase()) === -1) {
            return null;
        }
    }

    render = () => {
        const { isLoading, friends, activeTab, filter } = this.state;
        const { isAdmin, profile } = this.props;
        if (this.props.active !== "Team Mates") {
            return null;
        }

        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text="Loading" />
            )
        }

        if(activeTab === "Find Team Mates +"){
            <Redirect to={{pathname:"/search"}}/>
        }

        return (
            <EventViewSplitPane isExtended="true" active={this.state.activeTab} items={profile.isAdmin?["All Team Mates", "Recently Added", "by Sport", "Current City", "Hometown", "Find Team Mates +"]:["All Team Mates", "Recently Added", "by Sport", "Current City", "Hometown"]} setView={(d) => {
                if(d === "Find Team Mates +"){
                    window.location = "/search";
                } else{
                    this.setState({
                        activeTab: d
                    });
                }
            }}>
                {(activeTab !== "Find Team Mates +" && this.getCurrentList().length > 0) &&
                    <div className="group-members-view-list-filter-search" style={{marginBottom:"20px",marginTop:"-25px"}}>
                        <input value={filter} placeholder="Find member" style={{flex:1}} onChange={(e) => {
                            this.setState({ filter: e.target.value })
                        }} />
                        <i className="material-icons">search</i>
                    </div>
                }
                {activeTab !== "Find Team Mates +" &&
                    <div className="family-members">
                        {
                            this.getCurrentList().map((item, i) => {
                                //this.willRenderItem(item);
                                return (
                                    <FriendItem key={i} user={item} isAdmin={profile.isAdmin} />
                                )
                            })
                        }
                        {profile.isAdmin &&
                            <div className="family-member" onClick={() => {
                                this.setState({ activeTab: "Find Team Mates +" });
                            }}>
                                <div className="family-member-user" tabIndex="0">
                                    <img src="images/add_friend.svg" />
                                    <div>
                                        <span>Add Team Mates</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
                {activeTab !== "Find Team Mates +" &&this.getCurrentList().length === 0 &&
                    <EmptyState isShown={(this.getCurrentList().length === 0) ? true : true} text="No one found!" icon="people" />
                }
                {activeTab === "Find Team Mates +" &&
                    <PlayersYouMayKnow />
                }
            </EventViewSplitPane>
        )
    }
}

class PlayersYouMayKnow extends Component{
    constructor(p){
        super(p)
        this.state = {

        }
    }

    render(){
        return(
            <div />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Friends.js